import { render, staticRenderFns } from "./farmer-menu.vue?vue&type=template&id=8579659e&scoped=true"
import script from "./farmer-menu.vue?vue&type=script&lang=js"
export * from "./farmer-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8579659e",
  null
  
)

export default component.exports